/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';
import {
  MainContainer,
  BackgroundImage,
  TitleSection,
  TitleBack,
  TitleContainer,
  Title,
  InstalledMetalBuilding,
  InstalledMetalBuildingImageContainer,
  NewBadge,
  InstalledMetalBuildingInfo,
  CallUsButton,
  Actions,
  CallUsBtnContainer,
  ForkImage,
  ControlBtnContainer,
  SpaceEmitter,
  IconBtn
} from './styles'
import BackImg from '../../images/gallery_back.png';
import ForkImg from '../../images/fork.png';
import newBadgeImg from '../../images/new_badge.png';
import Slider from "react-slick";
import Img from 'gatsby-image'
import { breakpointdown } from '../Media/BreakpointDown';

const PreviousMetalBuildingsSection = ({ products }) => {
  const sliderRef = useRef()
  const [slidesToShow, setSlidesToShow] = useState(1);
  const [imgWidth, setImgWidth] = useState(768);
  const [imgHeight, setImgHeight] = useState(431);

  const handleWindowResize = () => {
    let sts
    if (window.innerWidth > breakpointdown.xxxl) sts = 3;
    else if (window.innerWidth > breakpointdown.xxl) sts = 2.5;
    else if (window.innerWidth > breakpointdown.xl) sts = 2;
    else if (window.innerWidth > breakpointdown.lg) sts = 1.5;
    else sts = 1;
    setSlidesToShow(sts);
    setImgWidth((window.innerWidth - 15) / sts);
    setImgHeight((window.innerWidth - 15) / sts * 0.56)
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const settings = {
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    speed: 300,
    arrows: false,
  };

  return (
    <MainContainer>
      <BackgroundImage
        alt=""
        src={BackImg}
      />

      <ForkImage
        alt=""
        src={ForkImg}
      />

      <TitleSection>
        <TitleBack>gallery</TitleBack>
        <TitleContainer>
          <Title>Our Recently Installed Metal Buildings</Title>
        </TitleContainer>

        <ControlBtnContainer>
          <IconBtn onClick={() => sliderRef.current.slickPrev()}>
            <svg width="11" height="21" viewBox="0 0 11 21" fill="none">
              <path d="M10 1L1 11L10 20" stroke="#DFDFDF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </IconBtn>

          <SpaceEmitter />

          <IconBtn onClick={() => sliderRef.current.slickNext()}>
            <svg width="11" height="21" viewBox="0 0 11 21" fill="none">
              <path d="M1 1L10 11L1 20" stroke="#DFDFDF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </IconBtn>
        </ControlBtnContainer>
      </TitleSection>

      <Slider {...settings} ref={sliderRef}>
        {products.map((product, i) => (
          <InstalledMetalBuilding key={i} no={i + 1}>
            <InstalledMetalBuildingImageContainer
              width={imgWidth}
              height={imgHeight}
            >
              <Img fluid={product.node.image.fluid} />
              {product.node.isNew && (
                <NewBadge
                  src={newBadgeImg}
                  alt="New Installed Metal Building Image"
                />
              )}
            </InstalledMetalBuildingImageContainer>

            <InstalledMetalBuildingInfo>
              <span className="size">{product.node.productName}</span>
              <span className="sku"> / SKU - {product.node.id.slice(-12)}</span>
            </InstalledMetalBuildingInfo>
          </InstalledMetalBuilding>
        ))}
      </Slider>

      <Actions>
        <CallUsBtnContainer>
          <svg width="17" height="20" viewBox="0 0 17 20" fill="none">
            <path d="M17 0V20L0 0H17Z" fill="#006D14" />
          </svg>
          <a href="tel:8776005980">
            <CallUsButton>
              <span className="desc">Call To Know The Price</span>
              <span className="name"><svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                <path d="M20.6238 15.7051C20.3537 15.4102 20.0265 15.1732 19.6621 15.0083C19.2977 14.8435 18.9037 14.7544 18.5038 14.7462C18.1061 14.757 17.7145 14.8461 17.3513 15.0085C16.9882 15.1709 16.6606 15.4033 16.3875 15.6925L14.9347 17.1365L14.7676 17.0498C14.615 16.9789 14.4664 16.8997 14.3227 16.8122C12.695 15.756 11.2516 14.44 10.0499 12.9164C9.56903 12.3354 9.15351 11.7033 8.8108 11.0314C9.11995 10.7386 9.41275 10.442 9.69677 10.1517L10.0298 9.81614C10.1052 9.73822 10.1831 9.66034 10.2397 9.60379C10.5502 9.33705 10.7996 9.00661 10.9712 8.63495C11.1427 8.26329 11.2323 7.85907 11.2339 7.44973C11.2354 7.04039 11.1489 6.63551 10.9802 6.26255C10.8115 5.8896 10.5645 5.55732 10.256 5.28823L8.80705 3.84303C8.64619 3.68217 8.4803 3.51503 8.31944 3.34035C8.02035 3.0312 7.66596 2.67053 7.32288 2.3551C7.05244 2.06532 6.72527 1.83426 6.36175 1.67627C5.99822 1.51829 5.60607 1.43677 5.2097 1.43677C4.81333 1.43677 4.42122 1.51829 4.05769 1.67627C3.69417 1.83426 3.367 2.06532 3.09656 2.3551L1.29319 4.16852C0.542852 4.9028 0.0869156 5.88616 0.0113269 6.93329C-0.0567951 8.33997 0.182978 9.74455 0.713852 11.049C1.68365 13.5702 3.08718 15.9022 4.86097 17.9395C7.17118 20.7286 10.0577 22.9845 13.3224 24.5523C14.8409 25.3375 16.4964 25.823 18.1984 25.9824H18.6294C19.2567 25.981 19.8767 25.8477 20.4492 25.5912C21.0216 25.3346 21.5337 24.9605 21.9522 24.4932C22.2332 24.1707 22.5315 23.8636 22.8457 23.5733C23.097 23.322 23.3333 23.1008 23.5394 22.8847C23.831 22.6047 24.064 22.2696 24.2248 21.8987C24.3855 21.5278 24.4708 21.1286 24.4756 20.7244C24.4667 20.3252 24.3782 19.9319 24.2152 19.5674C24.0523 19.2029 23.8183 18.8746 23.5268 18.6018L20.6238 15.7051ZM8.82338 7.77652C8.78019 7.83582 8.72751 7.88763 8.66752 7.92985L8.45015 8.14098C8.35841 8.23523 8.26791 8.32569 8.16611 8.42497C7.66343 8.94274 7.27763 9.3185 6.8026 9.7483C6.58239 9.95385 6.42879 10.2206 6.36159 10.5143C6.2944 10.8079 6.31667 11.115 6.42556 11.3958L6.45448 11.4813C6.90929 12.5237 7.50876 13.4967 8.23522 14.3717C9.59241 16.0909 11.2247 17.5738 13.066 18.7601C13.3048 18.9064 13.5515 19.0394 13.805 19.1585C13.9557 19.2281 14.1021 19.3066 14.2435 19.3935L14.3353 19.4463C14.5649 19.5655 14.8193 19.6287 15.078 19.631C15.286 19.6258 15.4909 19.5795 15.6809 19.4947C15.8709 19.41 16.0423 19.2884 16.1852 19.1372L18.02 17.3023C18.1358 17.171 18.2925 17.0825 18.4648 17.051C18.5615 17.0596 18.6554 17.088 18.7405 17.1345C18.8257 17.181 18.9004 17.2446 18.96 17.3212L21.9308 20.2833C22.0595 20.38 22.1448 20.5236 22.1683 20.6828C22.1918 20.8421 22.1517 21.0042 22.0565 21.1341C22.0296 21.1688 21.9998 21.2012 21.9673 21.2308L21.8894 21.2974C21.7423 21.4558 21.5915 21.6015 21.4344 21.7561L21.2622 21.9233C20.8933 22.2682 20.5418 22.6314 20.2091 23.0116C19.9984 23.2426 19.7398 23.4247 19.4513 23.5452C19.1628 23.6657 18.8514 23.7216 18.539 23.7091H18.3404C16.9426 23.5684 15.5847 23.1609 14.3403 22.5089C11.3688 21.0802 8.74163 19.0254 6.63922 16.4855C5.03455 14.6379 3.76502 12.5242 2.88793 10.2397C2.46977 9.25415 2.27782 8.18744 2.32619 7.11799C2.3603 6.62641 2.5752 6.16489 2.92943 5.82235L4.75163 4.00514C4.87236 3.87272 5.03633 3.78761 5.21411 3.7651C5.31432 3.77374 5.41175 3.80259 5.50052 3.84989C5.58929 3.89719 5.66757 3.96199 5.73063 4.04035C6.0247 4.31556 6.30494 4.60083 6.60152 4.91123L8.68639 6.99611C8.80735 7.08256 8.8895 7.21307 8.91512 7.35953C8.94074 7.50598 8.90781 7.65663 8.82338 7.77902V7.77652Z" fill="white" />
                <path d="M13.9532 6.85397C15.2464 7.08561 16.4375 7.70784 17.3663 8.6369C18.2952 9.56596 18.9171 10.7573 19.1485 12.0505C19.1921 12.3211 19.3314 12.5671 19.541 12.7437C19.7506 12.9204 20.0167 13.016 20.2908 13.0131H20.2971C20.3593 13.0109 20.4214 13.0054 20.4831 12.9968C20.7858 12.9445 21.0556 12.7745 21.2334 12.524C21.4112 12.2734 21.4825 11.9626 21.4319 11.6596C21.118 9.89298 20.2682 8.26568 18.9977 6.9986C17.7273 5.73151 16.0977 4.88602 14.3302 4.57685C14.0301 4.5298 13.7234 4.60149 13.4752 4.77673C13.227 4.95198 13.0568 5.21697 13.0007 5.51558C12.9735 5.6661 12.9767 5.82054 13.01 5.96981C13.0434 6.11909 13.1062 6.26019 13.1948 6.38486C13.2834 6.50952 13.3961 6.61525 13.5261 6.69581C13.6561 6.77637 13.8009 6.83013 13.952 6.85397H13.9532Z" fill="white" />
                <path d="M25.9862 11.4461C25.4818 8.59494 24.1122 5.96809 22.0634 3.92217C20.0146 1.87624 17.3857 0.510409 14.5338 0.0101065C14.3828 -0.0178997 14.2278 -0.015545 14.0778 0.0170865C13.9277 0.0497181 13.7857 0.111959 13.66 0.200139C13.5343 0.288318 13.4274 0.40068 13.3456 0.530653C13.2639 0.660626 13.2088 0.805592 13.1838 0.957085C13.1587 1.10858 13.1641 1.26355 13.1996 1.41293C13.2352 1.56232 13.3001 1.70312 13.3907 1.82709C13.4814 1.95107 13.5958 2.05572 13.7273 2.13494C13.8589 2.21417 14.0049 2.26638 14.1568 2.2885C16.5354 2.7053 18.728 3.84422 20.4367 5.5505C22.1455 7.25678 23.2876 9.44769 23.7078 11.8256C23.7493 12.0924 23.8843 12.3358 24.0887 12.5122C24.2932 12.6885 24.5537 12.7864 24.8238 12.7883C24.8401 12.7883 24.8602 12.7883 24.8765 12.7883C24.9331 12.7889 24.9895 12.7834 25.0449 12.772C25.3343 12.7236 25.5943 12.5666 25.7718 12.3331C25.9493 12.0995 26.0309 11.807 26 11.5153V11.4914L25.9862 11.4461Z" fill="white" />
              </svg>{` `}(877) 600-5980</span>
            </CallUsButton>
          </a>
          <svg width="17" height="20" viewBox="0 0 17 20" fill="none">
            <path d="M0 0V20L17 0H0Z" fill="#006D14" />
          </svg>
        </CallUsBtnContainer>
      </Actions>
    </MainContainer>
  )
}

export default PreviousMetalBuildingsSection;